import { Component, OnInit, AfterViewInit } from '@angular/core';
import { NaviService } from '../../services/navi.service';
declare var $: any;

@Component({
  selector: 'app-landingpage',
  templateUrl: './landingpage.component.html',
  styleUrls: ['./landingpage.component.css']
})
export class LandingpageComponent implements OnInit, AfterViewInit {
  public sendSuccess: Boolean = false;
  public alertInfo: Boolean = false;
  public outputInfo: String;

  // Vars for Input
  public inpName: String;
  public inpEmail: String;
  public inpSubject: String;
  public inpMessage: String;
  public toEmail: String = 'johannes-1.schmid@uni-ulm.de';
  public emailUri: String;


  constructor(private naviService: NaviService) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    $(document).ready(function () {
      const con1_height = $(window).height();
      $('.lp-con1').css({ 'height': con1_height });
    });

    $(document).ready(function () {
      const con3_height = $(window).height();
      $('.lp-con3').css({ 'height': con3_height });
    });

    /* Change navi background */
    $(document).ready(function () {

      function changeNavColor() {
        const navi = document.getElementById('lg-topnav-id');
        const windowHeight = $(window).height();
        const sPos = window.pageYOffset;
        const h = $('#lp-topnav-id').height();

        if (sPos >= 50) {
          $('#lp-topnav-id').addClass('lp-topnav-bg');
        } else {
          $('#lp-topnav-id').removeClass('lp-topnav-bg');
        }
      }
      window.onscroll = changeNavColor
    });




    let lastID;
    const topnav = $('#lp-topnav-id');
    const topnavHeight = topnav.outerHeight();

    const navItems = topnav.find('a');
    const scrollItems = navItems.map(function () {
      const item = $($(this).attr('href'));
      if (item.length) { return item; }
    });

    navItems.click(function (e) {
      const href = $(this).attr('href'),
        offsetTop = href === '#' ? 0 : $(href).offset().top - topnavHeight + 1;
      $('html, body').stop().animate({
        scrollTop: offsetTop
      }, 300);
      e.preventDefault();
    });

    $(window).scroll(function () {
      // Get container scroll position
      const fromTop = $(this).scrollTop() + topnavHeight;

      // Get id of current scroll item
      let cur = scrollItems.map(function () {
        if ($(this).offset().top < fromTop) {
          return this;
        }
      });
      // Get the id of the current element
      cur = cur[cur.length - 1];
      const id = cur && cur.length ? cur[0].id : '';

      if (lastID !== id) {
        lastID = id;
        // Set/remove active class
        navItems
          .removeClass('lp-nav-elem-active')
          .filter('[href="#' + id + '"]').addClass('lp-nav-elem-active');
      }
    });



  }


  public goToLogin() {
    location.href = '/login';
  }

  public goToRegistration() {
    location.href = '/registration';
  }


  public responsiveNav() {
    const x = document.getElementById('lp-topnav-id');
    if (x.className === 'lp-topnav') {
      x.className += ' lp-responsive';
    } else {
      x.className = 'lp-topnav';
    }
  }

  sendMessage()  {
    const subjectMail = encodeURI(this.inpSubject.toString());
    const bodyMail = encodeURI(this.inpMessage.toString());
    this.emailUri = 'mailto:' + this.toEmail + '?subject=' + subjectMail + '&body=' + bodyMail;

  }


}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/landingpage/landingpage.component.ts